import { render, staticRenderFns } from "./DirectOutbound.vue?vue&type=template&id=e2f408e4&"
import script from "./DirectOutbound.vue?vue&type=script&lang=js&"
export * from "./DirectOutbound.vue?vue&type=script&lang=js&"
import style0 from "./DirectOutbound.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports